<template>
    <div class="qcDetailPage">
        <div class="page_cards">
            <case-risk :caseDetail="caseDetail" @goBack="goBack"></case-risk>
        </div>
    </div>
</template>
<script>
import CaseRisk from '@/components/specializedQC/caseRisk.vue';
export default {
    components: { CaseRisk },
    data() {
        return {
            caseDetail: {},
            tableData: [
                {
                    date: '2016-05-02',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                },
                {
                    date: '2016-05-04',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1517 弄'
                },
                {
                    date: '2016-05-01',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1519 弄'
                },
                {
                    date: '2016-05-03',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1516 弄'
                }
            ]
        };
    },
    mounted() {
        this.getCaseDetail();
    },
    methods: {
        getCaseDetail() {
            if (!this.$route.query.id) {
                return;
            }

            this.$request({ method: 'post', url: `/ubi/api/xinjiang/case/detail/${this.$route.query.id}`, data: null }).then((res) => {
                if (res.code == 200) {
                    this.caseDetail = res.data;
                }
            });
        },
        goBack() {
            this.$router.go(-1);
        }
    }
};
</script>
<style lang="less" scoped>
.qcDetailPage {
    height: calc(100vh - 85px);
    overflow: auto;
}
</style>